import { AuthUser } from '../services/repositories/api-repository';
import { environment } from '../../../environments/environment';

export type ModuleKey =
  | 'dashboard'
  | 'agencies'
  | 'supervisors'
  | 'agents'
  | 'pos'
  | 'inventory'
  | 'btl'
  | 'logistics'
  | 'configurations'
  | 'roles'
  | 'profile'
  | 'reports'
  | 'alerts'
  | 'components-screen';

export type RouteAccessKey = ModuleKey;

const ROLE_MODULE_ACCESS: Record<AuthUser['role'], ModuleKey[]> = {
  admin: ['dashboard', 'agencies', 'supervisors', 'agents', 'pos', 'inventory', 'btl', 'logistics', 'configurations', 'roles', 'profile'],
  supervisor: ['dashboard', 'agencies', 'agents', 'pos', 'inventory', 'btl', 'logistics', 'profile'],
  agent: ['dashboard', 'profile']
};

const DEVELOPMENT_MODULE_ACCESS: ModuleKey[] = [
  'dashboard',
  'agencies',
  'supervisors',
  'agents',
  'pos',
  'inventory',
  'btl',
  'logistics',
  'reports',
  'alerts',
  'configurations',
  'roles',
  'profile',
  'components-screen'
];

// Centralized mock RBAC for shell module visibility until backend RBAC is connected.
export function getAllowedModulesForRole(role: AuthUser['role']): Set<ModuleKey> {
  const allowed = new Set<ModuleKey>(ROLE_MODULE_ACCESS[role] ?? []);

  if (environment.showDevelopmentScreens) {
    // Development builds intentionally expose every screen so QA can audit routes without changing role data.
    DEVELOPMENT_MODULE_ACCESS.forEach((moduleKey) => allowed.add(moduleKey));
  }

  return allowed;
}

// Route-level helper keeps mock sidebar and direct-URL access checks aligned.
export function canAccessMockModule(role: AuthUser['role'], key: RouteAccessKey): boolean {
  if (!environment.showDevelopmentScreens && (key === 'reports' || key === 'alerts' || key === 'components-screen')) {
    return false;
  }

  return getAllowedModulesForRole(role).has(key);
}
